import { useState, useEffect } from 'react';

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Retour en haut"
      className={`
        fixed bottom-28 right-6 z-50
        w-11 h-11 flex items-center justify-center
        bg-[#0D5C3A] text-white rounded-full
        border border-white/20
        transition-all duration-300 ease-in-out cursor-pointer
        hover:bg-[#0A3D2B] hover:scale-110
        ${visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}
      `}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}
